import Paragraph from '@editorjs/paragraph';
import type { ToolboxConfig } from '@editorjs/editorjs';

import { PARAGRAPH_SANITIZE } from '../sanitize-config';

// Note tool: thin subclass of EditorJS's Paragraph that only overrides the
// toolbox metadata so users can pick "Green text" from the block-add (+) menu
// and the cluster's save adapter can recognise the resulting block.type ===
// 'note' to persist it as a leaf TextBlock with style 'note'. All editing /
// rendering behaviour is inherited unchanged.
export class NoteTool extends Paragraph {
  static get pasteConfig(): false {
    return false;
  }

  static get sanitize() {
    return PARAGRAPH_SANITIZE;
  }

  // Enter inserts a line break within the block instead of splitting into a
  // new block — new blocks are only created via the Add-block menu.
  static get enableLineBreaks(): boolean {
    return true;
  }

  static get toolbox(): ToolboxConfig {
    return {
      title: 'Green text',
      icon:
        '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" ' +
        'stroke="currentColor" stroke-width="2" stroke-linecap="round" ' +
        'stroke-linejoin="round">' +
        '<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>' +
        '<polyline points="14 2 14 8 20 8"/>' +
        '<line x1="9" y1="13" x2="15" y2="13"/>' +
        '<line x1="9" y1="17" x2="13" y2="17"/>' +
        '</svg>',
    };
  }
}
